import React, {useEffect, useRef} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import {animateButtons, hideButtons} from "../../../../SqftUiFunctions";
import Bumpout from "../../../../canvas/core/controls/bumpout";
import workspace from "../../../../canvas/core/workspace";

const SqftNavBumpouts = (props) => {
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.bumpout;
  const buttonRefs = useRef({});

  useEffect(() => {
    const buttons = Object.values(buttonRefs.current);
    if (expanded) {
      animateButtons(buttons);
    } else {
      hideButtons(buttons);
    }

  }, [expanded]);

  const handleAddBumpoutClick = function () {
    workspace.setAllowBumpoutEdges(true);
    workspace.setAllowLineHighlight(true);
    Bumpout.addBumpout_onClick();
    setTimeout(function () {
      workspace.setAllowLineHighlight(false)
    }, 1000)
  };

  const handleResetBumpoutClick = function () {
    Bumpout.resetAllBumpouts();
  };

  return (
    <div className={"bumpout side single" + (expanded ? " expanded" : "")} data-content="bumpout" data-action="open-side">
      <div className="shapes-list sidebar-buttons sidebar-buttons-column">
        <button className="button button--inner shapes-icon button--add-bumpout" data-menu="add-bumpout"
                ref={(el) => buttonRefs.current[0] = el}
                onClick={() => handleAddBumpoutClick()}
                data-set="add-bumpout">
          <span className="button-text" data-text="sqft.navigation.submenu.addBumpout">Add Bumpout</span>
        </button>
        <button className="button button--inner shapes-icon button--reset-bumpout" data-menu="reset-bumpout"
                onClick={() => handleResetBumpoutClick()}
                ref={(el) => buttonRefs.current[1] = el}
                data-set="reset-bumpout">
          <span className="button-text" data-text="sqft.navigation.submenu.resetBumpout">Reset Bumpout</span>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavBumpouts);
